import SuiButton from "components/SuiButton";
import Prompt from "components/UpStyled/Prompt";
import { useState } from "react";
import api from "services/api";

const FollowButton = ({ user, size = "large", style = "w-full", ...rest }) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);
  const [isHovered, setIsHovered] = useState(false);

  const clickButton = (new_follow_type) => {
    api.social.follow(currentUser.id, new_follow_type).then(({ data }) => {
      return data;
    });
    setIsHovered(false);
    setCurrentUser({ ...currentUser, follow_type: new_follow_type });
  };
  return (
    <div
      className="${style} flex"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {currentUser.follow_type == 1 ? (
        isHovered ? (
          <SuiButton
            key={currentUser.id + "_Follow_1_H"}
            className={`${style} bg-[#fecaca] text-[#cc0033]`}
            size={size}
            circular
            color="secondary"
            variant="outlined"
            sx={{ width: "100%" }}
            onClick={(event) => {
              setDialogVisible(true);
            }}
            {...rest}
          >
            Unfollow
          </SuiButton>
        ) : (
          <SuiButton
            key={currentUser.id + "_Follow_1"}
            className={`${style} bg-[#000000] text-[#ffffff]`}
            size={size}
            circular
            color="secondary"
            variant="outlined"
            sx={{ width: "100%" }}
            {...rest}
          >
            Following
          </SuiButton>
        )
      ) : (
        <SuiButton
          key={currentUser.id + "_Follow_0"}
          className={`${style} bg-[#ffffff] text-[#000000]`}
          size={size}
          circular
          color="secondary"
          variant="outlined"
          sx={{ width: "100%" }}
          onClick={(event) => clickButton(1)}
          {...rest}
        >
          Follow
        </SuiButton>
      )}
      {dialogVisible && (
        <Prompt
          heading="Unfollow"
          text={`Are you sure you want to unfollow ` + currentUser.name + `?`}
          visible={dialogVisible}
          okText="Unfollow"
          okColor="error"
          handleOk={() => {
            setDialogVisible(false);
            clickButton(0);
          }}
          handleClose={() => setDialogVisible(false)}
        />
      )}
    </div>
  );
};

export default FollowButton;
